import { QUERY_PARAM_PAGE } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/constants'

/** Пишет `?page=` в адресную строку; первую страницу убирает из query. */
export default function setPageQueryParam(page: number) {
  if (!process.env.IS_CLIENT) {
    return
  }

  const url = new URL(window.location.href)

  if (page <= 1) {
    url.searchParams.delete(QUERY_PARAM_PAGE)
  } else {
    url.searchParams.set(QUERY_PARAM_PAGE, String(page))
  }

  window.history.replaceState(window.history.state, '', url)
}
